export default "__VITE_ASSET__943fa7bf__"